import { render, staticRenderFns } from "./Icmodal.vue?vue&type=template&id=3a50c3aa&"
import script from "./Icmodal.vue?vue&type=script&lang=js&"
export * from "./Icmodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports